import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";

@Component({
  selector: "app-cbox-profile-finance-paid-orders-list",
  templateUrl: "./cbox-profile-finance-paid-orders-list.component.html",
  styleUrls: ["./cbox-profile-finance-paid-orders-list.component.scss"],
  standalone: true,
  imports: [
    CommonModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CBoxProfileFinancePaidOrdersListComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}